import { HtmlResize } from "@logicflow/extension";

export default function registerSqlNode (lf) {
  lf.register('entity', () => {
    class ConnectNode extends  HtmlResize.view {
      setHtml(rootEl) {

          rootEl.innerHTML = "";
          const {
            properties: { fields, tableName }
          } = this.props.model;
          rootEl.setAttribute("class", "table-container");
          const container = document.createElement("div");
          container.className = `table-node table-color-${Math.ceil(
              Math.random() * 4
          )}`;
          const tableNameElement = document.createElement("div");
          tableNameElement.innerText = tableName;
          tableNameElement.className = "table-name";
          container.appendChild(tableNameElement);
          //console.log(fields)
          const fragment = document.createDocumentFragment();
          for (let i = 0;fields!=undefined && i < fields.length; i++) {
            const item = fields[i];
            const itemElement = document.createElement("div");
            itemElement.className = "table-feild";
            const itemKey = document.createElement("span");
            itemKey.innerText = item.key;
            const itemType = document.createElement("span");
            itemType.innerText = item.type;
            itemType.className = "feild-type";
            itemElement.appendChild(itemKey);
            itemElement.appendChild(itemType);
            fragment.appendChild(itemElement);
          }
          container.appendChild(fragment);
          rootEl.appendChild(container);


        // new Profile().$mount(el)
      }
    }
    class ConnectNodeModel extends HtmlResize.model {
      initNodeData(data) {
        super.initNodeData(data);
        this.width = 200;
        this.height = 100;

      }
      getNodeStyle() {
        const style = super.getNodeStyle();
        style.fill = "#f1a131";
        style.strokeWidth = 1;

        return style;
      }
    }
    return {
      view: ConnectNode,
      model: ConnectNodeModel
    }
  })
}